import CollectionView from '../../../views/collection';
import AutocompleteView from './autocompletion';
import AutoCompletionsTemplate from '../templates/autocompletions.html';
const { text } = window;

const Autocompletions = CollectionView.extend({
    template: AutoCompletionsTemplate,

    initialize({ el, query, collection, autocompleteBus, options = {} }) {
        this.el = el;
        this.collection = collection;
        this.query = query;
        this.autocompleteBus = autocompleteBus;
        this.options = options;
        this.$desktopInput = $('.Nav-searchInput');
        this.$mobileInput = $('.MobileNav-searchInput');
        this.$advancedSearch = $('.js-desktopAdvancedSearch');
        this.listenTo(this.collection, 'reset', this.emptyElAndClearActive);
        this.listenTo(this.collection, 'smartsync', this.smartRender);
        this.listenTo(autocompleteBus, 'quicksearch:blur', this.hideVisual);
        this.listenTo(autocompleteBus, 'quicksearch:focus', this.smartRender);
        this.listenTo(
            autocompleteBus,
            'quicksearch:highlightItem',
            this.highlightItem
        );
    },

    hideVisual() {
        if (this.options.desktop) {
            this.$advancedSearch.show();
        }
        // Hack until all the logic is moved into views
        if (this.options.mobile) {
            this.resetMobileSearchBar();
        }
        const listElement = $(this.el).find('.Autocompletions');
        if (listElement.children('.js-autocompletionsList').length > 0) {
            listElement[0].style.display = 'none';
            listElement.attr('aria-hidden', 'true');
            if ($(this.el).hasClass('js-quickSearchAutocompletionsDesktop')) {
                this.$desktopInput.attr('aria-expanded', 'false');
                this.$desktopInput.removeAttr('aria-activedescendant');
            } else {
                this.$mobileInput.removeAttr('aria-activedescendant');
            }
        }
        this.highlightedItemIndex = null;
    },

    emptyElAndClearActive() {
        if (this.options.desktop) {
            this.$advancedSearch.show();
        }
        // Hack until all the logic is moved into views
        if (this.options.mobile) {
            this.resetMobileSearchBar();
        }
        this.collection.invoke('set', { active: false });
        this.emptyEl();
        this.highlightedItemIndex = null;
        if ($(this.el).hasClass('js-quickSearchAutocompletionsDesktop')) {
            this.$desktopInput.attr('aria-expanded', 'false');
            this.$desktopInput
                .siblings('#search-label-desktop')
                .text(text('search'));
        } else {
            this.$mobileInput
                .parents('#search-form-mobile')
                .siblings('#search-label-mobile')
                .text(text('search'));
        }
    },

    resetMobileSearchBar() {
        // Mess of jquery until navbar can be systematically refactored
        $('.account-dropdown-mobile a').removeClass('hideMeImportant');
        $('.toggle-topbar.search').addClass('invisible');
        $('.toggle-topbar.menu-icon').removeClass('invisible');
        $('.toggle-topbar.browse').removeClass('invisible');
    },

    highlightItem(direction) {
        if (this.collection.models.length === 0) {
            return;
        }
        if (this.highlightedItemIndex == null) {
            this.highlightedItemIndex = direction > 0 ? 0 : direction;
        } else {
            this.highlightedItemIndex += direction;
        }
        if (this.highlightedItemIndex < 0) {
            this.highlightedItemIndex = this.views.length - 1;
        } else if (this.highlightedItemIndex >= this.collection.models.length) {
            this.highlightedItemIndex = 0;
        }
        const model = this.collection.models[this.highlightedItemIndex];
        this.collection.invoke('set', { active: false });
        model.set('active', true);
        this.autocompleteBus.trigger('quicksearch:fill', model.get('text'));
        if ($(this.el).hasClass('js-quickSearchAutocompletionsDesktop')) {
            this.$desktopInput.attr(
                'aria-activedescendant',
                this.highlightedItemIndex
            );
        } else {
            this.$mobileInput.attr(
                'aria-activedescendant',
                this.highlightedItemIndex
            );
        }
    },

    appendItems() {
        $('.js-autocompletionsList').append(this.temp);
    },

    smartRender() {
        let activeElShouldTriggerAutocomplete =
            $(document.activeElement).hasClass('js-quickSearchInput') ||
            $(document.activeElement).hasClass('Autocompletions-item');
        this.highlightedItemIndex = null;
        if (activeElShouldTriggerAutocomplete === true) {
            if (
                this.query.get('text').length &&
                this.collection.models.length
            ) {
                this.render();
                this.addAriaLabels();
                this.$advancedSearch.hide();
            } else {
                this.emptyEl();
                if (
                    $(this.el).hasClass('js-quickSearchAutocompletionsDesktop')
                ) {
                    this.$advancedSearch.show();
                    this.$desktopInput.attr('aria-expanded', 'false');
                    if (this.query.get('text').length) {
                        this.$desktopInput
                            .siblings('#search-label-desktop')
                            .text('');
                    } else {
                        this.$desktopInput
                            .siblings('#search-label-desktop')
                            .text(text('search'));
                    }
                } else if (this.query.get('text').length) {
                    this.$mobileInput
                        .parents('#search-form-mobile')
                        .siblings('#search-label-mobile')
                        .text('');
                } else {
                    this.$mobileInput
                        .parents('#search-form-mobile')
                        .siblings('#search-label-mobile')
                        .text(text('search'));
                }
            }
        }
    },

    createItemView({ model }) {
        return new AutocompleteView({
            model,
            query: this.query,
        });
    },

    addAriaLabels() {
        const autocompleteList = $(this.el).find('.js-autocompletionsList');
        autocompleteList.attr('aria-label', text('results.autocompletions'));
        if ($(this.el).hasClass('js-quickSearchAutocompletionsDesktop')) {
            this.$desktopInput.attr('aria-expanded', 'true');
            this.$desktopInput.removeAttr('aria-activedescendant');
            autocompleteList.attr('id', 'autocompletions-desktop');
            this.$desktopInput
                .siblings('#search-label-desktop')
                .text(text('results.autocompletionsReturned'));
        } else {
            this.$mobileInput.attr('aria-expanded', 'true');
            this.$mobileInput.removeAttr('aria-activedescendant');
            autocompleteList.attr('id', 'autocompletions-mobile');
            this.$mobileInput
                .parents('#search-form-mobile')
                .siblings('#search-label-mobile')
                .text(text('results.autocompletionsReturned'));
        }
    },
});

export default Autocompletions;
